import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import CallBox from '../../components/call_box/call_box';

import styles from './support.module.css';

const Support = () => {
  const { pathname } = useLocation();
  const pathArr = pathname.split('/');
  const pageTitle = pathArr[pathArr.length - 1] === 'faq' ? 'FAQ' : '자료실';

  return (
    <div className={styles.container}>
      <div className={styles.contents}>
        <h1 className={styles.title}>{pageTitle}</h1>
        <Outlet />
      </div>

      {pageTitle === 'FAQ' && <CallBox call={2} />}
    </div>
  );
};

export default Support;
